<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_2"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/02_introduction"><b><em>Introduction</em></b></a></p>
<p class="toc"><a href="#/xhtml/03_chapter01"><b>Chapter: I Antiquity</b></a></p>
<p class="toc"><span href="#/xhtml/04_chapter02" title="Link target outside of Sample"><b>Chapter II: Greek</b></span></p>
<p class="toc1"><span href="#/xhtml/04_chapter02#a01" title="Link target outside of Sample"><i>Plato</i></span></p>
<p class="toc1"><span href="#/xhtml/04_chapter02#a02" title="Link target outside of Sample"><i>Dioscorides</i></span></p>
<p class="toc1"><span href="#/xhtml/04_chapter02#a03" title="Link target outside of Sample"><i>Nonnus</i></span></p>
<p class="toc"><span href="#/xhtml/05_chapter03" title="Link target outside of Sample"><b>Chapter III: Romans</b></span></p>
<p class="toc1"><span href="#/xhtml/05_chapter03#a04" title="Link target outside of Sample"><i>Ovid</i></span></p>
<p class="toc"><span href="#/xhtml/06_chapter04" title="Link target outside of Sample"><b>Chapter IV: Orient</b></span></p>
<p class="toc"><span href="#/xhtml/07_chapter05" title="Link target outside of Sample"><b>Chapter V: India</b></span></p>
<p class="toc"><span href="#/xhtml/08_chapter06" title="Link target outside of Sample"><b>Chapter VI: Varieties and Occasions of Potions</b></span></p>
<p class="toc"><span href="#/xhtml/09_chapter07" title="Link target outside of Sample"><b>Chapter VII: Potency of Philtres</b></span></p>
<p class="toc"><span href="#/xhtml/10_chapter08" title="Link target outside of Sample"><b>Chapter VIII: Ingredients of Potions. Recipes. Anecdotes</b></span></p>
<p class="toc1"><span href="#/xhtml/10_chapter08#a05" title="Link target outside of Sample"><i>Ingredients</i></span></p>
<p class="toc"><span href="#/xhtml/11_chapter09" title="Link target outside of Sample"><b>Chapter IX: Middle Ages and Later</b></span></p>
<p class="toc1"><span href="#/xhtml/11_chapter09#a06" title="Link target outside of Sample"><i>Clauder</i></span></p>
<p class="toc"><span href="#/xhtml/12_chapter10" title="Link target outside of Sample"><b>Chapter X: Modern Times</b></span></p>
<p class="toc"><span href="#/xhtml/bio" title="Link target outside of Sample"><b><em>About the Author</em></b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?fcb82956